import { TimflowSteadyForm } from "../../types/forms/capture";
import { TimflowSteadyRequest } from "../../types/model/calculation";

const n = (v: number | null | undefined) => v ?? undefined;

const first = (v: number | number[] | null | undefined) =>
  n(Array.isArray(v) ? v[0] : v);

export const fromTimflowPayload = (
  saved: TimflowSteadyRequest,
  current: TimflowSteadyForm,
): TimflowSteadyForm => {
  const z = (saved.model?.z ?? []).map((value) => ({ value: n(value) }));

  return {
    ...current,
    model: {
      kaq: first(saved.model?.kaq),
      npor: first(saved.model?.npor),
      z: z.length >= 2 ? z : [...z, ...Array(2 - z.length).fill({})],
      topboundary: saved.model?.topboundary ?? current.model.topboundary,
      hstar: n(saved.model?.hstar),
    },

    uflowEnabled: !!saved.uflow,
    uflow: {
      slope: n(saved.uflow?.slope),
      angle: n(saved.uflow?.angle),
    },

    wells: (saved.wells ?? []).map((w) => ({
      captureId: w.captureId,
      inputId: w.inputId,
      rw: n(w.rw),
      res: n(w.res),
      layers: n(w.layers as number | null | undefined),
      label: w.label ?? undefined,
    })),

    constants: (saved.constants ?? []).map((c) => ({
      xr: n(c.xr),
      yr: n(c.yr),
      hr: n(c.hr),
      layer: n(c.layer),
    })),

    recharge: (saved.recharge ?? []).map((r) => ({
      xc: n(r.xc),
      yc: n(r.yc),
      R: n(r.R),
      N: n(r.N),
      layer: n(r.layer),
      label: r.label ?? undefined,
    })),

    rivers: (saved.rivers ?? []).map((r) => ({
      xy: (r.xy ?? []).map((p: any) =>
        Array.isArray(p) ? { x: n(p[0]), y: n(p[1]) } : { x: n(p.x), y: n(p.y) },
      ),
      hls: n(r.hls),
      res: n(r.res),
      wh: n(r.wh),
      order: n(r.order),
      layers: n(r.layers as number | null | undefined),
      dely: n(r.dely),
      label: r.label ?? undefined,
    })),

    captureZone: {
      nt: n(saved.captureZone?.nt),
      zstart: n(saved.captureZone?.zstart),
      hstepmax: n(saved.captureZone?.hstepmax),
      vstepfrac: n(saved.captureZone?.vstepfrac),
      nstepmax: n(saved.captureZone?.nstepmax),
      silent: String(saved.captureZone?.silent ?? ".") as "true" | "false" | ".",
    },

    days: current.days,
  };
};